import { lazy } from 'react';
import { RouteObject } from 'react-router';

// project import
import Loadable from 'components/Loadable';

// render pages
const PropertyList = Loadable(lazy(() => import('pages/property/List')));
const PropertyCreate = Loadable(lazy(() => import('pages/property/Create')));
const PropertyView = Loadable(lazy(() => import('pages/property/View')));
const PropertyEdit = Loadable(lazy(() => import('pages/property/Edit')));
const ApartmentConsumptionEdit = Loadable(lazy(() => import('pages/apartment/Consumption')));

// ==============================|| PARTNER SUB ROUTING ||============================== //
const PropertyRoutes: RouteObject = {
    path: 'property',
    children: [
        {
            path: '',
            element: <PropertyList />,
        },
        {
            path: 'new',
            element: <PropertyCreate />,
        },
        {
            path: ':id',
            element: <PropertyView />,
        },
        {
            path: ':id/edit',
            element: <PropertyEdit />,
        },
        {
            path: 'consumption/:id/edit',
            element: <ApartmentConsumptionEdit />,
        }
    ],
};
export default PropertyRoutes;
